<div class="c">
<main class="container" role="main">
  <h1>Contact Us</h1>
  <p>
    We'd love to hear from you! Whether you have a question about your
    account, a partnership proposal, or feedback about the MoreTech
    platform, please fill out the form below.
  </p>

  <form (submit)="handleSubmit($event)" id="contactForm">
    <div>
      <label for="name">Full Name</label>
      <input type="text" id="name" name="name" required minlength="2" />
    </div>

    <div>
      <label for="email">Email Address</label>
      <input type="email" id="email" name="email" required />
    </div>

    <div>
      <label for="subject">Subject</label>
      <input type="text" id="subject" name="subject" required minlength="3" />
    </div>

    <div>
      <label for="message">Message</label>
      <textarea
        id="message"
        name="message"
        required
        minlength="10"
        maxlength="2000"
        placeholder="Please enter at least 10 characters (max 2000)"
      ></textarea>
    </div>

    <button type="submit" id="submitBtn" [disabled]="isSubmitting">
      {{ isSubmitting ? 'Sending...' : 'Send Message' }}
    </button>

    <p *ngIf="formResponse" class="form-success">{{ formResponse }}</p>
    <p *ngIf="formError" class="form-error">{{ formError }}</p>
  </form>

  <p>
    <br>
    Or reach us directly at:<br />
    <strong>Email:</strong>
    <a href="mailto:support&#64;moretech.ps"> support&#64;moretech.ps</a><br />
    <strong>Address:</strong> Palestine, Ramallah
  </p>

  <footer>
    &copy; {{ currentYear }} MoreTech. All rights reserved.
  </footer>
</main>
</div>